/**
 * @generated SignedSource<<9f68a3951711b2cf30657bf5b216befe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginInput = {
  email: string;
  password: string;
};
export type RegisterWithInvite_login_Mutation$variables = {
  input: LoginInput;
};
export type RegisterWithInvite_login_Mutation$data = {
  readonly login: {
    readonly token: string;
  } | null;
};
export type RegisterWithInvite_login_Mutation = {
  response: RegisterWithInvite_login_Mutation$data;
  variables: RegisterWithInvite_login_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LoginPayload",
    "kind": "LinkedField",
    "name": "login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterWithInvite_login_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegisterWithInvite_login_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d0066c84d49d14566931c91663f74aae",
    "id": null,
    "metadata": {},
    "name": "RegisterWithInvite_login_Mutation",
    "operationKind": "mutation",
    "text": "mutation RegisterWithInvite_login_Mutation(\n  $input: LoginInput!\n) {\n  login(input: $input) {\n    token\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e3de7a71302aa44bb876c5139f35c89";

export default node;
